var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import Comment from './Comment';
import CommentWriter from './CommentWriter';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 100px;\n\n  > .comment-list {\n    border-top: 1px solid #ddd;\n    border-bottom: 1px solid #ddd;\n    margin-bottom: 50px;\n\n    > div {\n      :not(:first-child) {\n        border-top: 1px solid #ddd;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  margin-top: 100px;\n\n  > .comment-list {\n    border-top: 1px solid #ddd;\n    border-bottom: 1px solid #ddd;\n    margin-bottom: 50px;\n\n    > div {\n      :not(:first-child) {\n        border-top: 1px solid #ddd;\n      }\n    }\n  }\n"])));
export var GET_COMMENTS = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query GetComments($postId: String!) {\n    comments: commentsByPost(postId: $postId) {\n      id\n      author {\n        id\n        name\n        role\n      }\n      createdAt\n      updatedAt\n      content\n    }\n  }\n"], ["\n  query GetComments($postId: String!) {\n    comments: commentsByPost(postId: $postId) {\n      id\n      author {\n        id\n        name\n        role\n      }\n      createdAt\n      updatedAt\n      content\n    }\n  }\n"])));
var CommentArea = /** @class */ (function (_super) {
    __extends(CommentArea, _super);
    function CommentArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentArea.prototype.render = function () {
        var postId = this.props.postId;
        return (React.createElement(Query, { query: GET_COMMENTS, variables: {
                postId: postId
            } }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading)
                return React.createElement(Loading, null);
            if (error || !data.comments)
                return React.createElement(Error, { error: error });
            var comments = data.comments;
            return (React.createElement(Container, null,
                React.createElement("div", { className: "comment-list" }, comments.map(function (comment, idx) {
                    return React.createElement(Comment, { key: idx, comment: comment, postId: postId });
                })),
                React.createElement(CommentWriter, { postId: postId })));
        }));
    };
    return CommentArea;
}(React.Component));
export default CommentArea;
var templateObject_1, templateObject_2;
